import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { ProductsComponent } from './products.component';
import { ProductsRoutingModule } from './products-routing.module';
import { ProductsDetailComponent } from './products-detail/products-detail.component';
import { ProductFormComponent } from './products-form/products-form.component';

@NgModule({
  declarations: [
    ProductsComponent, 
    ProductsDetailComponent, 
    ProductFormComponent,
  ],
  imports: [
    SharedModule,
    ProductsRoutingModule
  ]
})
export class ProductsModule { }
